/* eslint-disable */
import { Context } from '@nuxt/types/app'
import Vue from 'vue'

// APIClient
import { APIClient as AlgoliaAPIClient } from '@/infrastructure/network/Algolia/APIClient'
import { APIClient as MonitaroAPIClient } from '@/infrastructure/network/Monitaro/APIClient'
import { APIClient as OpenAiAPIClient } from '@/infrastructure/network/OpenAi/APIClient'

// Repositories
import AppRepository from '@/repositories/AppRepository'
import AppointmentRepository from '@/repositories/AppointmentRepository'
import AuthRepository from '@/repositories/AuthRepository'
import DataRepository from '@/repositories/DataRepository'
import DoctorRepository from '@/repositories/DoctorRepository'
import FilterRepository from '@/repositories/FilterRepository'
import HospitalRepository from '@/repositories/HospitalRepository'
import MessageRepository from '@/repositories/MessageRepository'
import NotificationRepository from '@/repositories/NotificationRepository'
import RoomRepository from '@/repositories/RoomRepository'
import ScheduleRepository from '@/repositories/ScheduleRepository'
import TalkRepository from '@/repositories/TalkRepository'
import UserRepository from '@/repositories/UserRepository'

// Gateways
import AlgoliaGateway from '@/gateways/Algolia'
import MonitaroGateway from '@/gateways/Monitaro'
import OpenAiGateway from '@/gateways/OpenAi'

// Services
import LogService from '@/services/LogService'
// import RouterService from '@/services/RouterService'

export default (ctx: Context) => {
  const { store, app } = ctx
  const algoliaAPIClient = new AlgoliaAPIClient(ctx)
  const monitaroAPIClient = new MonitaroAPIClient(ctx)
  const openAiAPIClient = new OpenAiAPIClient(ctx)

  Vue.prototype.App = {
    state: new AppRepository(app.$cookies, store),
    appointment: new AppointmentRepository(app.$cookies, store),
    auth: new AuthRepository(app.$cookies, store),
    data: new DataRepository(app.$cookies, store),
    doctor: new DoctorRepository(app.$cookies, store),
    filter: new FilterRepository(app.$cookies, store),
    hospital: new HospitalRepository(app.$cookies, store),
    message: new MessageRepository(app.$cookies, store),
    notification: new NotificationRepository(app.$cookies, store),
    room: new RoomRepository(app.$cookies, store),
    schedule: new ScheduleRepository(app.$cookies, store),
    talk: new TalkRepository(app.$cookies, store),
    user: new UserRepository(app.$cookies, store),
    algoliaGateway: new AlgoliaGateway(algoliaAPIClient),
    monitaroGateway: new MonitaroGateway(monitaroAPIClient),
    openAiGateway: new OpenAiGateway(openAiAPIClient),
    logService: new LogService(ctx, app.$sentry)
    // routerService: new RouterService(ctx)
  }

  ctx.App = {
    state: new AppRepository(app.$cookies, store),
    appointment: new AppointmentRepository(app.$cookies, store),
    auth: new AuthRepository(app.$cookies, store),
    data: new DataRepository(app.$cookies, store),
    doctor: new DoctorRepository(app.$cookies, store),
    filter: new FilterRepository(app.$cookies, store),
    hospital: new HospitalRepository(app.$cookies, store),
    message: new MessageRepository(app.$cookies, store),
    notification: new NotificationRepository(app.$cookies, store),
    room: new RoomRepository(app.$cookies, store),
    schedule: new ScheduleRepository(app.$cookies, store),
    talk: new TalkRepository(app.$cookies, store),
    user: new UserRepository(app.$cookies, store),
    algoliaGateway: new AlgoliaGateway(algoliaAPIClient),
    monitaroGateway: new MonitaroGateway(monitaroAPIClient),
    openAiGateway: new OpenAiGateway(openAiAPIClient),
    logService: new LogService(ctx, app.$sentry)
    // routerService: new RouterService(ctx)
  }
}
